/* lib/api/pendingChanges.js — клиент подготовленных правок чата (порт из frontend/src/lib/api/pendingChanges.js, 1:1).
 * commit/cancel pending-change (без LLM, чат-квоту не тратят) + откат через versioning-REST. */
import { apiFetch } from './client.js';

// Фаза 3 (chat-entities): подтверждение / отмена подготовленной правки.
// Эндпойнты без LLM — чат-квоту не тратят.
export const commitPendingChange = (id) =>
  apiFetch(`/api/chats/pending-changes/${id}/commit/`, { method: 'POST' });

export const cancelPendingChange = (id) =>
  apiFetch(`/api/chats/pending-changes/${id}/cancel/`, { method: 'POST' });

// Откат после применения: восстановить pre-edit версию сущности через
// существующий versioning-REST. version_number — номер версии (не PK).
const RESTORE_BASE = {
  ttk: (id) => `/api/ttk/${id}/versions`,
  card: (id) => `/api/kitchen/cards/${id}/versions`,
  menu: (id) => `/api/menus/${id}/versions`,
};

export const restoreEntityVersion = (kind, targetId, versionNumber) => {
  const base = RESTORE_BASE[kind];
  if (!base || versionNumber == null) {
    return Promise.resolve({ ok: false, status: 0, data: null });
  }
  return apiFetch(`${base(targetId)}/${versionNumber}/restore/`, { method: 'POST' });
};
